export default __webpack_public_path__ + "static/header-iconic-link-insights-link-icon2.url-fa8f4bb91cda9c280fbf0c48e619c623.svg";